var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingPayWire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511",
    gradientUnits: "userSpaceOnUse",
    x1: -6209.999,
    y1: -467.699,
    x2: -6208.999,
    y2: -467.699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M51.413 80.415v10.839M42.842 80.415v10.839M51.413 148.822v10.545M42.842 148.822v10.545M103.64 80.415v79.257M94.543 80.415v79.257M156.492 80.415v79.257M147.395 80.415v79.257M22.506 80.415h155.265l-77.284-38.504zM32.019 159.652h139.468v12.54H32.019z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511",
    gradientUnits: "userSpaceOnUse",
    x1: 31.343,
    y1: 133.648,
    x2: 83.913,
    y2: 133.648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.593 129.487v8.499h35.55v10.27l14.52-15.228-14.874-13.988v10.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511",
    gradientUnits: "userSpaceOnUse",
    x1: 17.328,
    y1: 105.848,
    x2: 69.898,
    y2: 105.848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M68.648 110.009v-8.499h-35.55V91.24l-14.52 15.228 14.874 13.988v-10.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511",
    gradientUnits: "userSpaceOnUse",
    x1: 79.745,
    y1: 56.732,
    x2: 120.531,
    y2: 56.732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_4bde97fa3134908bd8e8a8e0ce6831d8bf8a4162da69fb6ea992601aeb776511)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M119.281 61.285l-18.795-9.365-19.491 9.624"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingPayWire);
export default __webpack_public_path__ + "static/media/billingPayWire.800a3de62485f48f1e2226803c8f2ace.svg";
export { ForwardRef as ReactComponent };